module.exports = __webpack_public_path__ + "static/media/i.4b38681b.png";